export const COURSE_CATEGORY_REQUEST = "COURSE_CATEGORY_REQUEST";
export const COURSE_CATEGORY_SUCCESS = "COURSE_CATEGORY_SUCCESS";
export const COURSE_CATEGORY_FAILED = "COURSE_CATEGORY_FAILED";
